import { Routes } from "@angular/router";
import { GestionInventarioIAComponent } from "./inventario-ia/gestion-inventario-ia/gestion-inventario-ia.component";
import { ModalInventarioIAComponent } from "./inventario-ia/modal-inventario-ia/modal-inventario-ia.component";
import { HistorialInventarioIAComponent } from "./inventario-ia/historial-inventario-ia/historial-inventario-ia.component";
import { ConsultaInventarioIAComponent } from "./inventario-ia/consulta-inventario-ia/consulta-inventario-ia.component";
import { DetalleInventarioIAComponent } from "./inventario-ia/detalle-inventario-ia/detalle-inventario-ia.component";
import { CatalogosInventarioIAComponent } from "./inventario-ia/catalogos-inventario-ia/catalogos-inventario-ia.component";
import { GestionSolicitudesIaComponent } from "./solicitudes-ia/gestion-solicitudes-ia/gestion-solicitudes-ia.component";
import { MonitoreoInventarioIAComponent } from "./inventario-ia/monitoreo-inventario-ia/monitoreo-inventario-ia.component";
import { LibroMatrizRiesgosIAComponent } from "./matriz-riesgos-ia/libro-matriz-riesgos-ia/libro-matriz-riesgos-ia.component";
import { GestionMatricesIAComponent } from "./matriz-riesgos-ia/gestion-matrices-ia/gestion-matrices-ia.component";
import { ModalMatrizRiesgosIAComponent } from "./matriz-riesgos-ia/modal-matriz-riesgos-ia/modal-matriz-riesgos-ia.component";
import { HistorialMatrizRiesgosIAComponent } from "./matriz-riesgos-ia/historial-matriz-riesgos-ia/historial-matriz-riesgos-ia.component";
import { HojasApoyoIAComponent } from "./matriz-riesgos-ia/hojas-apoyo-ia/hojas-apoyo-ia.component";
import { CambiosPorAprobarIAComponent } from "./matriz-riesgos-ia/cambios-por-aprobar-ia/cambios-por-aprobar-ia.component";
import { GestionIncidenciasIAComponent } from "./incidencias-ia/gestion-incidencias-ia/gestion-incidencias-ia.component";
import { GestionIncidenciasSeguridadComponent } from "./incidencias-seguridad/gestion-incidencias-seguridad/gestion-incidencias-seguridad.component";
import { GestionIncidenciasHostComponent } from "./incidencias-host/gestion-incidencias-host/gestion-incidencias-host.component";
import { AltaDenunciaComponent } from "./denuncias/alta-denuncia/alta-denuncia.component";
import { ConfirmacionDenunciaComponent } from "./denuncias/confirmacion-denuncia/confirmacion-denuncia.component";
import { DashboardDenunciasComponent } from "./denuncias/dashboard-denuncias/dashboard-denuncias.component";
import { KanbanDenunciasComponent } from "./denuncias/kanban-denuncias/kanban-denuncias.component";
import { DetalleDenunciaComponent } from "./denuncias/detalle-denuncia/detalle-denuncia.component";
import { InicioDenunciasComponent } from "./denuncias/inicio-denuncias/inicio-denuncias.component";
import { DenunciasConfiguracionComponent } from "./denuncias/denuncias-configuracion/denuncias-configuracion.component";
import { EvaluacionesIaComponent } from "./evaluaciones-ia/evaluaciones-ia.component";
import { HomologacionModelosComponent } from "./homologacion-modelos/homologacion-modelos.component";
import { HomologacionConsultaComponent } from "./homologacion-modelos/consulta/homologacion-consulta.component";
import { ParametrosBscComponent } from "./bsc/parametros/parametros-bsc.component";
import { CargaExcelBscComponent } from "./bsc/carga-excel/carga-excel-bsc.component";
import { IndicadoresGeneralesBscComponent } from "./bsc/indicadores/indicadores-generales-bsc.component";
import { TableroBscComponent } from "./bsc/tablero/tablero-bsc.component";
import { DetalleAreaBscComponent } from "./bsc/area/detalle-area-bsc.component";
import { FichaKpiBscComponent } from "./bsc/kpi/ficha-kpi-bsc.component";
import { PlaneacionMetasBscComponent } from "./bsc/planeacion/planeacion-metas-bsc.component";
import { MiBscComponent } from "./bsc/mi-bsc/mi-bsc.component";
import { CierreTrimestreBscComponent } from "./bsc/cierre/cierre-trimestre-bsc.component";
import { BandejaRevisionBscComponent } from "./bsc/revision/bandeja-revision-bsc.component";
import { ComparativoAnualBscComponent } from "./bsc/comparativo/comparativo-anual-bsc.component";
import { TableroCcComponent } from "./calidad-codigo/tablero/tablero-cc.component";
import { DetalleCcComponent } from "./calidad-codigo/proyecto/detalle-cc.component";
import { ReportesCcComponent } from "./calidad-codigo/reportes/reportes-cc.component";
import { ConfiguracionCcComponent } from "./calidad-codigo/configuracion/configuracion-cc.component";

import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { CalendarioVacacionesComponent } from "./vacaciones/calendario-vacaciones/calendario-vacaciones.component";
import { SolicitudVacacionesComponent } from "./vacaciones/solicitud-vacaciones/solicitud-vacaciones.component";
import { SeguimientoVacacionesComponent } from "./vacaciones/seguimiento-vacaciones/seguimiento-vacaciones.component";
import { AuthGuard } from "./security/auth-guard.service";
import { redirigirRutaNoEncontrada } from "./security/ruta-no-encontrada.guard";
import { portalPorTipoDeUsuario } from "./security/portal-cliente.guard";
import { WizardComponent } from "./security/ajustesUsuario/ajustes-usuario.component";
import { DatosPersonalesComponent } from "./security/ajustesUsuario/datos-personales/datos-personales.component";
import { PasswordComponent } from "./security/ajustesUsuario/password/password.component";
import { TokensComponent } from "./security/ajustesUsuario/tokens/tokens.component";
import { LoginComponent } from "./security/login/login.component";
import { ModificaperfilComponent } from "./security/perfil/modificaperfil/modificaperfil.component";
import { PerfilComponent } from "./security/perfil/perfil.component";
import { PerfilAltaComponent } from "./security/perfil/perfilalta/perfilalta.component";
import { RestauraPassComponent } from "./security/restauraPass/restauraPass.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { GestionPublicidadComponent } from "./dashboard/gestion-publicidad/gestion-publicidad.component";
import { ModelPublicidadComponent } from "./dashboard/model-publicidad/model-publicidad.component";
import { ConfiguracionesComponent } from "./configuraciones/configuraciones/configuraciones.component";
import { AltaIncidenciaComponent } from "./incidencias/alta-incidencia/alta-incidencia.component";
import { DetallesincidenciaComponent } from "./incidencias/detallesincidencia/detallesincidencia.component";
import { ReportIncidenciaComponent } from "./incidencias/report-incidencia/report-incidencia.component";
import { DetallesIncidenciaDesarrolloComponent } from "./incidencias/detallesIncidenciaDesarrollo/detallesIncidenciaDesarrollo.component";
import { IncidenciaDesa } from "./incidencias/incidenciasDesarrollo/incidenciades.component";
import { IncidenciaQA } from "./incidencias/IncidenciasQA/incidenciaqa.component";
import { IncidenciaCliente } from "./incidencias/incidenciaCliente/incidenciacliente.component";
import { ClienteIncidenciasDashboardComponent } from "./incidencias/cliente-dashboard/cliente-incidencias-dashboard.component";
import { GestionEmpleadosComponent } from "./empleado/gestion-empleados/gestion-empleados.component";
import { HistorialSolserComponent } from "./empleado/HistorialSolser/HistorialSolser.component";
import { ModalEmpleadoComponent } from "./empleado/modal-empleado/modal-empleado.component";
import { SolicitudTicketsComponent } from "./tickets/solicitud/solicitud-tickets/solicitudTickets.component";
import { GestionTicketsComponent } from "./tickets/atencion/gestion-tickets/gestion-tickets.component";
import { GestionCteTicketsComponent } from "./tickets/solicitud/gestion-cte-tickets/gestion-cte-tickets.component";
import { DetalleTicketsComponent } from "./tickets/atencion/detalle-tickets/detalle-tickets.component";
import { ModalTicketsComponent } from "./tickets/atencion/detalle-tickets/modal-tickets/modal-tickets.component";
import { ReportesTicketsComponent } from "./tickets/general/reportes-tickets/reportes-tickets.component";
import { GestionTicketsDepuradosComponent } from "./tickets/gestion-tickets-depurados/gestion-tickets-depurados.component";
import { ResumenTicketComponent } from "./tickets/general/resumen-ticket/resumen-ticket.component";
import { GestionAreasComponent } from "./areas/gestion-areas/gestion-areas.component";
import { ModalAreaComponent } from "./areas/modalArea/modal-area.component";
import { SolicitudTicketsEditComponent } from "./tickets/solicitud/solicitud-tickets-edit/solicitud-tickets-edit.component";
import { GestionPrioridadesComponent } from "./tickets/prioridad/gestion-prioridades/gestion-prioridades.component";
import { ModalPrioridadComponent } from "./tickets/prioridad/modal-prioridad/modal-prioridad.component";
import { ModalReporteComponent } from "./tickets/general/reportes-tickets/modal-reporte/modal-reporte.component";
import { SolicitudCapacitacionTicketsComponent } from "./tickets/solicitud/solicitud-capacitacion-tickets/solicitud-capacitacion-tickets.component";
import { SolicitudPerfilTicketsComponent } from "./tickets/solicitud/perfil-tickets/solicitud-perfil-tickets/solicitudPerfilTickets.component";
import { ConsultarUsuariosComponent } from "./clientes/consultar-usuarios/consultar-usuarios.component";
import { GestionClientesComponent } from "./clientes/gestion-clientes/gestion-clientes.component";
import { AddclientemodalComponent } from "./clientes/addclientemodal/addclientemodal.component";
import { DesarrolloClientesComponent } from "./clientes/desarrollo-clientes/desarrollo-clientes.component";
import { GestionProspeccionComponent } from "./clientes/gestion-prospeccion/gestion-prospeccion.component";
import { ReporteProspeccion } from "./clientes/reporte-prospeccion/reporte-prospeccion.component";
import { TareaConsultaComponent } from "./tarea-diaria/tarea-consulta/tarea-consulta.component";
import { TareaAltaComponent } from "./tarea-diaria/tarea-alta/tarea-alta.component";
import { TareaTiempoComponent } from "./tarea-diaria/tarea-tiempo/tarea-tiempo.component";
import { BitacorasComponent } from "./tarea-diaria/bitacoras/bitacoras.component";
import { AutorizacionesTiempoExtraComponent } from "./tarea-diaria/autorizaciones-tiempo-extra/autorizaciones-tiempo-extra.component";
import { CapturaManualSemanalComponent } from "./tarea-diaria/captura-manual-semanal/captura-manual-semanal.component";
import { GestionHorariosComponent } from "./tarea-diaria/horarios/gestion-horarios/gestion-horarios.component";
// Modulo de asistencia. Los paths de abajo tienen que coincidir EXACTO
// con el FACTORY de cada adm_menu del script
// 2026-09-09-QA-asistencia-sitio-perfiles-menu.sql: esa cadena es a la
// vez el routerLink que arma el sidebar y la llave con la que el backend
// comprueba el acceso al modulo.
import { MonitoreoComponent } from "./asistencia/monitoreo/monitoreo.component";
import { MiAsistenciaComponent } from "./asistencia/mi-asistencia/mi-asistencia.component";
import { MiPlanComponent } from "./asistencia/mi-plan/mi-plan.component";
import { UbicacionesComponent } from "./asistencia/ubicaciones/ubicaciones.component";
import { EditorUbicacionComponent } from "./asistencia/ubicaciones/editor-ubicacion/editor-ubicacion.component";
import { EstacionesComponent } from "./asistencia/estaciones/estaciones.component";
import { ParametrosComponent } from "./asistencia/parametros/parametros.component";
import { ModalidadesComponent } from "./asistencia/modalidades/modalidades.component";
import { TelefonosComponent } from "./asistencia/telefonos/telefonos.component";
import { PlanesComponent } from "./security/planes/planes.component";
import { ClientesComponent } from "./plataforma/clientes/clientes.component";
import { GestionMenuComponent } from "./plataforma/menu/gestion-menu.component";
import { ConfiguracionComponent } from "./configuracion/configuracion.component";
import { HorarioEditorComponent } from "./tarea-diaria/horarios/horario-editor/horario-editor.component";
import { AsignacionHorarioComponent } from "./tarea-diaria/horarios/asignacion-horario/asignacion-horario.component";
import { DashboardTareasComponent } from "./tareas/DashboardTareas/dashboardTareas.component";
import { GestionAplicacionesComponent } from "./fise/gestion-aplicaciones/gestion-aplicaciones.component";
import { ConfiguracionAplicacionesServidoresComponent } from "./fise/configuracion-aplicaciones-servidores/configuracion-aplicaciones-servidores.component";
import { GestionServidoresComponent } from "./fise/gestion-servidores/gestion-servidores.component";
import { GestionServidoresAplicacionesComponent } from "./fise/gestion-servidores-aplicaciones/gestion-servidores-aplicaciones.component";
import { ConsultaServidoresAplicacionesComponent } from "./fise/consulta-servidores-aplicaciones/consulta-servidores-aplicaciones.component";
import { OportunidadesMarketingComponent } from "./proceso-operativo/oportunidades/oportunidades-marketing/oportunidades-marketing.component";
import { OportunidadesODPComponent } from "./proceso-operativo/oportunidades/oportunidades-odp/oportunidades-odp.component";
import { OportunidadesDesarrolladoresComponent } from "./proceso-operativo/oportunidades/oportunidades-desarrolladores/oportunidades-desarrolladores.component";
import { NombreGruposComponent } from "./proceso-operativo/grupos/nombre-grupos.component";
import { SeguimientoOportunidadComponent } from "./proceso-operativo/oportunidades/oportunidades-marketing/seguimiento-oportunidad/seguimiento-oportunidad.component";
import { SeguimientoOportunidadOdpComponent } from "./proceso-operativo/oportunidades/oportunidades-odp/seguimiento-oportunidad-odp/seguimiento-oportunidad-odp.component";
import { SeguimientoOportunidadDesarrolladorComponent } from "./proceso-operativo/oportunidades/oportunidades-desarrolladores/seguimiento-oportunidad-desarrollador/seguimiento-oportunidad-desarrollador.component";
import { GestionProyectosComponent } from "./proyectos/gestion-proyectos/gestion-proyectos.component";
import { ConsultaProyectosComponent } from "./proyectos/seguimiento/proyectos/consulta/consulta-proyectos.component";
import { AdmProyectosComponent } from "./proyectos/admin-proyectos/adm-proyectos.component";
import { ModalAddProyComponent } from "./proyectos/admin-proyectos/modal-agregar-proyecto/modal-agregar-proyecto.component";
import { ProyectoPaginaComponent } from "./proyectos/proyecto-pagina/proyecto-pagina.component";
import { DetalleVersionComponent } from "./proyectos/proyecto-pagina/detalle-version/detalle-version.component";
import { ModalAgregarEtapaComponent } from "./proyectos/modal-agregar-etapa/modal-agregar-etapa.component";
import { GestionRiesgosComponent } from "./proyectos/gestion_riesgos/gestion_riesgos.component";
import { RiesgoEditorPageComponent } from "./proyectos/gestion_riesgos/riesgo-editor-page/riesgo-editor-page.component";
import { AltaRiesgoComponent } from "./gestion-riesgos/alta-riesgo/alta-riesgo-wizard.component";
import { ConsultaRiesgoComponent } from "./gestion-riesgos/consulta-riesgo-areas/consulta-riesgo-areas.component";
import { ConsultaHuCuxProyectoComponent } from "./hucu/consultaxProyecto/consulta-hu-cux-proyecto/consulta-hu-cux-proyecto.component";
import { NotificacionesComponent } from "./notificaciones/notificaciones.component";
import { DetalleProyectoComponent } from "./proyectos/seguimiento/proyectos/detalle/detalle-proyecto.component";
import { CatalogoPromptsComponent } from "./prompts/catalogo-prompts/catalogo-prompts.component";
import { NuevaSolicitudComponent } from "./solicitudes/nueva-solicitud/nueva-solicitud.component";
import { aMisMantenimiento, aSolicitudIa } from "./solicitudes/nueva-solicitud/rutas-viejas";
import { GestionMantenimientoComponent } from "./mantenimiento/gestion-mantenimiento/gestion-mantenimiento.component";
import { MantenimientoModulosComponent } from "./mantenimiento-modulos/administrar/mantenimiento-modulos.component";
import { ModuloEnMantenimientoComponent } from "./mantenimiento-modulos/aviso/modulo-en-mantenimiento.component";
export const AppRoutes: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },

  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    // El usuario del portal (CLIENTE) solo navega por /CLIENTE/** y su
    // cuenta; el personal nunca entra a /CLIENTE/**. Es UX: la seguridad
    // real la pone el backend (PortalClienteInterceptor).
    canActivateChild: [portalPorTipoDeUsuario],
    children: [
      {
        path: "admin",
        children: [
          { path: "empleados", component: GestionEmpleadosComponent, canActivate: [AuthGuard], },
          { path: "perfil", component: PerfilComponent, canActivate: [AuthGuard], },
          { path: "configgeneral", component: ConfiguracionesComponent, canActivate: [AuthGuard], },
          // Menu Planes bajo Administracion (factory del padre /admin +
          // hijo planes = /admin/planes). Que modulos tiene contratados MI
          // empresa, solo lectura: los planes los vende Solser (plataforma).
          { path: "planes", component: PlanesComponent, canActivate: [AuthGuard], },
          // Mantenimiento de módulos (16/10/2026): poner pantallas y funciones
          // en mantenimiento. Se entra desde Configuración (hoja
          // admin/mantenimiento-modulos); el servidor exige esa hoja.
          { path: "mantenimiento-modulos", component: MantenimientoModulosComponent, canActivate: [AuthGuard], },
          {
            path: "inventario-ia",
            children: [
              { path: "", redirectTo: "gestion", pathMatch: "full" },
              { path: "gestion", component: GestionInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "consulta", component: ConsultaInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "detalle/:id", component: DetalleInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "catalogos", component: CatalogosInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "alta", component: ModalInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "edicion/:id", component: ModalInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "historial/:id", component: HistorialInventarioIAComponent, canActivate: [AuthGuard] },
              { path: "monitoreo/:id", component: MonitoreoInventarioIAComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            // El menu (adm_menu id 1053) apunta a 'admin/prompts': este
            // path tiene que coincidir exactamente con ese FACTORY, que
            // es ademas la llave con la que el backend comprueba el
            // acceso al modulo.
            path: "prompts",
            component: CatalogoPromptsComponent,
            canActivate: [AuthGuard],
          },
          {
            // Solicitudes de IA (SIA). Igual que prompts: cada path tiene
            // que coincidir EXACTAMENTE con el factory de su menu, porque
            // ese mismo texto es la llave con la que el backend autoriza
            // (SolicitudIABuss.MENU_SOLICITUD). Pedir una IA vive dentro de
            // «Nueva solicitud» (12/10/2026): la ruta vieja lleva ahí.
            path: "solicitudes-ia",
            children: [
              { path: "", redirectTo: aSolicitudIa, pathMatch: "full" },
              { path: "solicitud", redirectTo: aSolicitudIa },
              { path: "gestion", component: GestionSolicitudesIaComponent, canActivate: [AuthGuard] },
            ],
          },
           {
            // Evaluaciones IA Solser. Igual que prompts: el path tiene que
            // coincidir EXACTAMENTE con el factory de su menu
            // (admin/evaluaciones-ia), que es ademas la llave con la que el
            // backend autoriza (EvalProveedorBuss.MENU).
            path: "evaluaciones-ia",
            component: EvaluacionesIaComponent,
            canActivate: [AuthGuard],
          },
          {
            // Homologación de Modelos IA. Como Evaluaciones: el path tiene
            // que coincidir EXACTAMENTE con el factory de su menú
            // (admin/homologacion-modelos), que es además la llave con la
            // que el backend autoriza (HomologacionBuss.MENU).
            path: "homologacion-modelos",
            children: [
              { path: "", component: HomologacionModelosComponent, canActivate: [AuthGuard] },
              // La consulta: su factory (admin/homologacion-modelos/consulta) es la llave de Consulta.
              { path: "consulta", component: HomologacionConsultaComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            // Mantenimiento (instalaciones y edificio). Cada path coincide
            // EXACTAMENTE con el factory de su menu, que es la llave con la
            // que el backend autoriza (MantenimientoBuss.MENU_SOLICITUD).
            // Se pide y se sigue desde el asistente «Nueva solicitud»
            // (12/10/2026): la ruta vieja de «las mías» lleva ahí.
            path: "mantenimiento",
            children: [
              { path: "", redirectTo: aMisMantenimiento, pathMatch: "full" },
              { path: "solicitud", redirectTo: aMisMantenimiento },
              { path: "gestion", component: GestionMantenimientoComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            path: "vacaciones",
            children: [
              { path: "", redirectTo: "calendario", pathMatch: "full" },
              { path: "calendario", component: CalendarioVacacionesComponent, canActivate: [AuthGuard] },
              // La pantalla del colaborador. El path tiene que coincidir
              // exactamente con el factory del menu (adm_menu id 1052),
              // que es ademas la llave con la que el backend comprueba
              // el permiso.
              { path: "solicitud", component: SolicitudVacacionesComponent, canActivate: [AuthGuard] },
              // Las dos de solo lectura son la MISMA pantalla con distinto
              // alcance: "Mi equipo" (menu admin/vacaciones/equipo) pide su
              // gente; "Seguimiento RH" (admin/vacaciones/seguimiento) pide
              // toda la empresa. El servidor concede el alcance segun los
              // menus del usuario, asi que entrar por la URL no da mas.
              {
                path: "equipo",
                component: SeguimientoVacacionesComponent,
                canActivate: [AuthGuard],
                data: { alcance: "EQUIPO" },
              },
              {
                path: "seguimiento",
                component: SeguimientoVacacionesComponent,
                canActivate: [AuthGuard],
                data: { alcance: "TODOS" },
              },
            ],
          },
          {
            // BSC (FOR-011). Cada path tiene que coincidir EXACTAMENTE con
            // el factory de su hoja de adm_menu (admin/bsc/<path>), que es
            // además la llave con la que el backend autoriza. En F0 las 7
            // hojas abrían una pantalla temporal "en construcción"; se
            // reemplazó ruta por ruta en F2-F7 (docs/BSC.md §7 y §11).
            // F2: parametros ya es T4. F3.5: carga-excel ya es T1. F4.2:
            // tablero ya es A1. F4.3: el detalle de área (A2) y la ficha de
            // KPI (A3) cuelgan del tablero; no son hojas del menú y el
            // backend solo les exige la raíz admin/bsc. F5.2: planeacion ya
            // es T3 (?anio=&idBscArea= abre esa área y ese año). F6.4: mi-bsc
            // ya es C1 (?anio=&idBscArea=). F6.5: el cierre del trimestre (C3)
            // cuelga de mi-bsc; lo abren C1 y A2 (?desde=area), no es hoja del
            // menú y el backend le exige mi-bsc o tablero. F6.6: revision ya es
            // C2, con el detalle del envío a un lado (?anio=&trimestre=&estatus=&id=).
            // F7.1: comparativo ya es T2 (?anioA=&anioB=&idBscArea=&modo=&q=); con
            // ella ya no queda ninguna pantalla temporal "en construcción".
            path: "bsc",
            children: [
              { path: "", redirectTo: "tablero", pathMatch: "full" },
              { path: "indicadores", component: IndicadoresGeneralesBscComponent, canActivate: [AuthGuard] },
              { path: "tablero", component: TableroBscComponent, canActivate: [AuthGuard] },
              { path: "tablero/area/:idBscArea", component: DetalleAreaBscComponent, canActivate: [AuthGuard] },
              { path: "tablero/kpi/:idEjercicioKpi", component: FichaKpiBscComponent, canActivate: [AuthGuard] },
              { path: "mi-bsc", component: MiBscComponent, canActivate: [AuthGuard] },
              { path: "mi-bsc/cierre/:idEjercicio/:trimestre", component: CierreTrimestreBscComponent, canActivate: [AuthGuard] },
              { path: "revision", component: BandejaRevisionBscComponent, canActivate: [AuthGuard] },
              { path: "carga-excel", component: CargaExcelBscComponent, canActivate: [AuthGuard] },
              { path: "comparativo", component: ComparativoAnualBscComponent, canActivate: [AuthGuard] },
              { path: "planeacion", component: PlaneacionMetasBscComponent, canActivate: [AuthGuard] },
              { path: "parametros", component: ParametrosBscComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            // Calidad de código (SonarQube). Cada path tiene que coincidir
            // EXACTAMENTE con el factory de su hoja de adm_menu
            // (admin/calidad-codigo/<path>, script 02 de Scripts SQL/QA/CALIDAD-CODIGO),
            // que es además la llave con la que el backend autoriza
            // (CalidadCodigoAccesos: la hoja raíz admin/calidad-codigo más la
            // llave «solo Solser»; configuracion exige también su propia hoja).
            // El detalle de un proyecto (proyecto/:id, con el id del COS)
            // cuelga del tablero: no es hoja del menú y el sidebar marca
            // Tablero mientras se está en él (SE_ABREN_DESDE). Ver
            // docs/CALIDAD_CODIGO.md §5.
            path: "calidad-codigo",
            children: [
              { path: "", redirectTo: "tablero", pathMatch: "full" },
              { path: "indicadores", component: IndicadoresGeneralesBscComponent, canActivate: [AuthGuard] },
              { path: "tablero", component: TableroCcComponent, canActivate: [AuthGuard] },
              { path: "proyecto/:id", component: DetalleCcComponent, canActivate: [AuthGuard] },
              { path: "reportes", component: ReportesCcComponent, canActivate: [AuthGuard] },
              { path: "configuracion", component: ConfiguracionCcComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            // El menú (adm_menu id 1036) apunta a 'admin/matriz-riesgos-ia/gestion':
            // este path debe coincidir exactamente con ese FACTORY.
            path: "matriz-riesgos-ia",
            children: [
              { path: "", redirectTo: "gestion", pathMatch: "full" },
              // "gestion" es el libro completo con una pestaña por hoja del
              // Excel; el listado de activos vive dentro, en su pestaña.
              { path: "gestion", component: LibroMatrizRiesgosIAComponent, canActivate: [AuthGuard] },
              { path: "alta", component: ModalMatrizRiesgosIAComponent, canActivate: [AuthGuard] },
              { path: "edicion/:id", component: ModalMatrizRiesgosIAComponent, canActivate: [AuthGuard] },
              { path: "historial/:id", component: HistorialMatrizRiesgosIAComponent, canActivate: [AuthGuard] },
            ],
          },
          {
            path: "areas",
            children: [
              {
                path: "",
                component: GestionAreasComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: ModalAreaComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: ModalAreaComponent,
                canActivate: [AuthGuard],
              },
            ],
          },

          { path: "ajustes", component: WizardComponent, canActivate: [AuthGuard], },
          { path: "datospersonales", component: DatosPersonalesComponent },
          { path: "password", component: PasswordComponent },
          { path: "tokens", component: TokensComponent },


          { path: "perfilalta", component: PerfilAltaComponent, canActivate: [AuthGuard] }, // ALTA PERFIL
          { path: "perfilalta/:pId", component: PerfilAltaComponent, canActivate: [AuthGuard] },
          { path: "modificaperfil/:id", component: ModificaperfilComponent, canActivate: [AuthGuard] },
          { path: "modificaperfil", redirectTo: "perfil", pathMatch: "full" },
        ],
      },
      {
        path: "NOTIFICACION",
        children: [
          {
            path: "detalle",
            component: NotificacionesComponent,
            canActivate: [AuthGuard],
          },
        ],
      },

      { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard] },
      {
            path: "seguimiento",
            component: ConsultaProyectosComponent,
            canActivate: [AuthGuard],
      },
         {
        path: "consultaSeguimientos/detalle/:projectId",
        component: DetalleProyectoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "DENUNCIAS",
        children: [
          // Admin
          { path: "dashboard", component: DashboardDenunciasComponent, canActivate: [AuthGuard] },
          { path: "kanban", component: KanbanDenunciasComponent, canActivate: [AuthGuard] },
          { path: "detalle/:id", component: DetalleDenunciaComponent, canActivate: [AuthGuard] },
          { path: "configuracion", component: DenunciasConfiguracionComponent, canActivate: [AuthGuard] },

        ],
      },
      {
        path: "PUBLICIDAD",
        component: GestionPublicidadComponent,
        canActivate: [AuthGuard],
      },
      { path: "ModalPrioridad", component: ModelPublicidadComponent },
      {
        path: "METRICAS",
        children: [
          {
            path: "graficas_esfuerzo",
            redirectTo: "/dashboard",
            pathMatch: "full",
          },
          {
            path: "resumen_metricas",
            redirectTo: "/dashboard",
            pathMatch: "full",
          },
          {
            path: "calendario_graficas",
            redirectTo: "/dashboard",
            pathMatch: "full",
          },
          {
            path: "defectos_graficas",
            redirectTo: "/dashboard",
            pathMatch: "full",
          },
        ],
      },

      { path: "CONFGRAL", component: ConfiguracionesComponent },
      {
        path: "INCIDENCIAS",
        children: [
          {
            path: "INC_DESARROLLO",
            children: [
              {
                path: "",
                component: IncidenciaDesa,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "detalle/:id",
                component: DetallesIncidenciaDesarrolloComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "INC_QA",
            children: [
              {
                path: "",
                component: IncidenciaQA,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: AltaIncidenciaComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "reporte",
                component: ReportIncidenciaComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "detalle/:id",
                component: DetallesincidenciaComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "INC_CLIENTE",
            component: IncidenciaCliente,
            canActivate: [AuthGuard],
          },
            {
              path: "INC_IA",
              children: [
              {
                path: "",
                component: GestionIncidenciasIAComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                redirectTo: "",
                pathMatch: "full",
              },
              {
                path: "edicion/:id",
                redirectTo: "",
                pathMatch: "full",
              },
              {
                path: "detalle/:id",
                redirectTo: "",
                pathMatch: "full",
                },
              ],
            },
            {
              path: "INC_SEGURIDAD",
              children: [
                {
                  path: "",
                  component: GestionIncidenciasSeguridadComponent,
                  canActivate: [AuthGuard],
                  pathMatch: "full",
                },
                {
                  path: "alta",
                  redirectTo: "",
                  pathMatch: "full",
                },
                {
                  path: "edicion/:id",
                  redirectTo: "",
                  pathMatch: "full",
                },
                {
                  path: "detalle/:id",
                  redirectTo: "",
                  pathMatch: "full",
                },
              ],
            },
            {
              path: "INC_HOST",
              children: [
                {
                  path: "",
                  component: GestionIncidenciasHostComponent,
                  canActivate: [AuthGuard],
                  pathMatch: "full",
                },
                {
                  path: "alta",
                  redirectTo: "",
                  pathMatch: "full",
                },
                {
                  path: "edicion/:id",
                  redirectTo: "",
                  pathMatch: "full",
                },
                {
                  path: "detalle/:id",
                  redirectTo: "",
                  pathMatch: "full",
                },
              ],
            },
            {
            path: "ALTAINCIDENCIA",
            component: AltaIncidenciaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "incDetalle",
            component: DetallesincidenciaComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "CLIENTE",
        children: [
          {
            path: "incidencias",
            component: ClienteIncidenciasDashboardComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "incidencias/alta",
            component: AltaIncidenciaComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "EMPLEADO",
        children: [
          {
            path: "GESTION_EMPLEADOS",
            children: [
              {
                path: "",
                component: GestionEmpleadosComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: ModalEmpleadoComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: ModalEmpleadoComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "HISTORIAL_EMPLEADOS",
            component: HistorialSolserComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "TICKETS",
        children: [
          { path: "SolicitudTickets", component: SolicitudTicketsComponent },
          {
            path: "Admin",
            component: GestionTicketsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "Cte",
            component: GestionCteTicketsComponent,
            canActivate: [AuthGuard],
          },
          { path: "DetalleTickets", redirectTo: "Admin", pathMatch: "full" },
          {
            path: "DetalleTickets/:id",
            component: DetalleTicketsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "DetalleWidget/:id",
            component: DetalleTicketsComponent,
            canActivate: [AuthGuard],
            data: {
              viewMode: "client",
              returnUrl: "/TICKETS/Cte",
            },
          },
          { path: "ModalTickets", component: ModalTicketsComponent },
          { path: "SolicitudReportes", component: ReportesTicketsComponent },
          {
            path: "GestionTicketsDepurados",
            component: GestionTicketsDepuradosComponent,
          },
          { path: "resumenTicket", component: ResumenTicketComponent },
          { path: "GestionAreas", component: GestionAreasComponent },
          { path: "ModalArea", component: ModalAreaComponent },
          {
            path: "SolicitudTicketsEdit",
            component: SolicitudTicketsEditComponent,
          },
          {
            path: "GestionPrioridades",
            component: GestionPrioridadesComponent,
          },
          { path: "ModalPrioridad", component: ModalPrioridadComponent },
          { path: "ModalReporte", component: ModalReporteComponent },
          { path: "DetalleWidget", redirectTo: "Cte", pathMatch: "full" },
          {
            path: "SolCapacitacion",
            component: SolicitudCapacitacionTicketsComponent,
          },
          { path: "SolPerfil", component: SolicitudPerfilTicketsComponent },
        ],
      },

      {
        path: "CLIENTES",
        children: [
          {
            path: "CONSULTAR_USUARIOS",
            component: ConsultarUsuariosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "GESTION_CLIENTES",
            children: [
              {
                path: "",
                component: GestionClientesComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: AddclientemodalComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: AddclientemodalComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "DEFECTOS_CLIENTES",
            component: DesarrolloClientesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "PROSPECCION",
            component: GestionProspeccionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "REPORTE_PROSPECCION",
            component: ReporteProspeccion,
            canActivate: [AuthGuard],
          },
        ],
      },
      // Configuracion: una entrada fija abajo del menu que abre esta pagina
      // con tarjetas; cada tarjeta es una hoja del menu que el usuario ya
      // tiene, asi que la pagina no reparte permisos.
      { path: "configuracion", component: ConfiguracionComponent, canActivate: [AuthGuard] },
      // El aviso de un módulo en mantenimiento: a esta página manda el
      // guardia de rutas (AuthGuard), que a ella nunca la bloquea.
      { path: "en-mantenimiento", component: ModuloEnMantenimientoComponent, canActivate: [AuthGuard] },
      // «Nueva solicitud»: el asistente que deja escoger Ticket, IA o
      // Mantenimiento y abre su proceso. Tickets e IA se abren tal cual.
      {
        path: "solicitudes",
        children: [
          { path: "", redirectTo: "nueva", pathMatch: "full" },
          { path: "nueva", component: NuevaSolicitudComponent, canActivate: [AuthGuard] },
        ],
      },
      {
        // Plataforma (Solser): clientes y sus planes. Padre /plataforma +
        // hijo plataforma/clientes (empieza con el padre + /, asi que el
        // sidebar lo usa tal cual). El backend exige el menu en cada llamada.
        path: "plataforma",
        children: [
          { path: "", redirectTo: "clientes", pathMatch: "full" },
          { path: "clientes", component: ClientesComponent, canActivate: [AuthGuard] },
          // El menu de todas las empresas se arma aqui: adm_menu es una sola.
          { path: "menu", component: GestionMenuComponent, canActivate: [AuthGuard] },
        ],
      },
      {
        // Modulo de asistencia. Va como grupo propio y no bajo TAREA
        // porque el menu cuelga de su propio sitio (ASISTENCIA).
        //
        // OJO CON EL FACTORY DEL MENU. El sidebar no usa el factory de la
        // hoja tal cual: CONCATENA el del padre con el del hijo
        // (getMenuRouterLink), y solo se salta la concatenacion cuando el
        // del hijo empieza con el del padre mas una diagonal, comparando
        // MAYUSCULAS. Por eso el padre es '/asistencia' en minusculas y no
        // '/ASISTENCIA': con la version en mayusculas el startsWith no
        // engancha, la URL sale '/ASISTENCIA/asistencia/monitoreo', no
        // existe, y el comodin manda al dashboard. El precedente correcto
        // es vacaciones ('admin/vacaciones' + 'admin/vacaciones/calendario').
        path: "asistencia",
        children: [
          { path: "", redirectTo: "mi-asistencia", pathMatch: "full" },
          { path: "monitoreo", component: MonitoreoComponent, canActivate: [AuthGuard] },
          { path: "mi-asistencia", component: MiAsistenciaComponent, canActivate: [AuthGuard] },
          { path: "mi-plan", component: MiPlanComponent, canActivate: [AuthGuard] },
          { path: "ubicaciones", component: UbicacionesComponent, canActivate: [AuthGuard] },
          // Alta y edicion de un sitio como pagina, no como dialogo: con el
          // mapa dentro el dialogo no cabia en la ventana y se cortaba.
          { path: "ubicaciones/alta", component: EditorUbicacionComponent, canActivate: [AuthGuard] },
          { path: "ubicaciones/edicion/:id", component: EditorUbicacionComponent, canActivate: [AuthGuard] },
          { path: "estaciones", component: EstacionesComponent, canActivate: [AuthGuard] },
          { path: "modalidades", component: ModalidadesComponent, canActivate: [AuthGuard] },
          { path: "telefonos", component: TelefonosComponent, canActivate: [AuthGuard] },
          // Herramientas de administracion del cliente colgadas del modulo:
          // un cliente que solo contrato ASISTENCIA no tiene el sitio COS y
          // por tanto no ve Administracion. Personal es la misma Gestion de
          // Empleados; Licencias, la misma pantalla de Planes.
          { path: "personal", component: GestionEmpleadosComponent, canActivate: [AuthGuard] },
          { path: "licencias", component: PlanesComponent, canActivate: [AuthGuard] },
          { path: "parametros", component: ParametrosComponent, canActivate: [AuthGuard] },
        ],
      },
      {
        path: "TAREA",
        children: [
          {
            path: "tareaConsulta",
            component: TareaConsultaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "tareaAlta",
            component: TareaAltaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "tareaTiempo",
            component: TareaTiempoComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "bitacoras",
            component: BitacorasComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "autorizaciones",
            component: AutorizacionesTiempoExtraComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "captura-manual-semanal",
            component: CapturaManualSemanalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "horarios",
            component: GestionHorariosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "horarios/alta",
            component: HorarioEditorComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "horarios/edicion/:id",
            component: HorarioEditorComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "horarios/asignacion",
            component: AsignacionHorarioComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "DASHBOARD_TAREAS",
            component: DashboardTareasComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "FISE",
        children: [
          {
            path: "GESTION_APLICACIONES",
            component: GestionAplicacionesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "CONFIGURACION_SERVIDORES_APLICACIONES",
            component: ConfiguracionAplicacionesServidoresComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "GESTION_SERVIDORES",
            component: GestionServidoresComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "SERVIDORES_APLICACIONES",
            component: GestionServidoresAplicacionesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "CONSULTA_SERVIDORES_APLICACIONES",
            component: ConsultaServidoresAplicacionesComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "PROCESO",
        children: [
          {
            path: "oportunidadmarketing",
            component: OportunidadesMarketingComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "oportunidadODP",
            component: OportunidadesODPComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "oportunidaddesarrollador",
            component: OportunidadesDesarrolladoresComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "grupos",
            component: NombreGruposComponent,
            canActivate: [AuthGuard],
          },
          // {path: 'addOportunidad', component: ModalAddOportComponent, canActivate: [AuthGuard]},
          {
            path: "seguimiento-marketing",
            component: SeguimientoOportunidadComponent,
          },
          {
            path: "seguimiento-oportunidad-odp",
            component: SeguimientoOportunidadOdpComponent,
          },
          {
            path: "seguimiento-desarrollo",
            component: SeguimientoOportunidadDesarrolladorComponent,
          },
        ],
      },
      {
        path: "PERFILES",
        children: [
          { path: "perfilalta/:pId", component: PerfilAltaComponent, canActivate: [AuthGuard] },
          {
            path: "perfil",
            component: PerfilComponent,
            canActivate: [AuthGuard],
          },
          { path: "perfilalta", component: PerfilAltaComponent, canActivate: [AuthGuard] }, // ALTA PERFIL
          { path: "modificaperfil/:id", component: ModificaperfilComponent, canActivate: [AuthGuard] },
          { path: "modificaperfil", redirectTo: "perfil", pathMatch: "full" },
        ],
      },

      {
        path: "ODP",
        children: [
          {
            path: "VISUALIZARPROY",
            component: GestionProyectosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/edicion/:id",
            component: ModalAddProyComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id",
            component: ProyectoPaginaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id/version/:idVersion",
            component: DetalleVersionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/alta/:idProyecto",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/edicion/:idProyecto/:idEtapa",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "consultaSeguimientos",
            component: ConsultaProyectosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "admproyectos",
            children: [
              {
                path: "",
                component: AdmProyectosComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "gestriesgos",
            component: GestionRiesgosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "riesgos/alta/:idProyecto",
            component: RiesgoEditorPageComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "VISUALIZARPROY",
        component: GestionProyectosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "VISUALIZARPROY/proyecto/edicion/:id",
        component: ModalAddProyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "VISUALIZARPROY/proyecto/:id",
        component: ProyectoPaginaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "VISUALIZARPROY/proyecto/:id/version/:idVersion",
        component: DetalleVersionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "VISUALIZARPROY/etapa/alta/:idProyecto",
        component: ModalAgregarEtapaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "VISUALIZARPROY/etapa/edicion/:idProyecto/:idEtapa",
        component: ModalAgregarEtapaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "riesgos/alta/:idProyecto",
        component: RiesgoEditorPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "LIDER",
        children: [
          {
            path: "VISUALIZARPROY",
            component: GestionProyectosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/edicion/:id",
            component: ModalAddProyComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id",
            component: ProyectoPaginaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id/version/:idVersion",
            component: DetalleVersionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/alta/:idProyecto",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/edicion/:idProyecto/:idEtapa",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "admproyectos",
            children: [
              {
                path: "",
                component: AdmProyectosComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "gestriesgos",
            component: GestionRiesgosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "riesgos/alta/:idProyecto",
            component: RiesgoEditorPageComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "RIESGOS",
        children: [
          // Configuración de las hojas de apoyo del FOS-005.
          //
          // Vive AQUÍ y no bajo "admin" porque su menú cuelga de "Gestión
          // Riesgos" (adm_menu 211, FACTORY '/RIESGOS'), y el sidebar arma el
          // enlace de un hijo pegando el factory del padre con el del hijo
          // (getMenuRouterLink). Con el factory 'hojasApoyoIA' resulta
          // '/RIESGOS/hojasApoyoIA', que es esta ruta; si el factory trajera
          // 'admin/...' saldría '/RIESGOS/admin/...' y no existiría.
          // La Matriz de Riesgos IA, desde que su menú cuelga de "Gestión
          // Riesgos" (FACTORY 'matrizRiesgosIA'). Las rutas viejas bajo
          // admin/matriz-riesgos-ia se CONSERVAN: alta, edición e historial
          // viven ahí, el modal y el historial navegan de regreso a
          // 'gestion' con ruta absoluta, y los marcadores viejos siguen
          // abriendo.
          {
            path: "matrizRiesgosIA",
            component: LibroMatrizRiesgosIAComponent,
            canActivate: [AuthGuard],
          },
          // Gestión de Riesgos: una matriz por área. El tablero da de alta
          // las matrices y a cada una le genera su menú con el factory
          // 'matriz/<id>', que el sidebar convierte en '/RIESGOS/matriz/<id>'
          // y cae en la ruta con parámetro de aquí abajo. Una sola ruta
          // atiende a todas las matrices, incluidas las que aún no existen.
          {
            path: "gestionRiesgos",
            component: GestionMatricesIAComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "matriz/:idMatriz",
            component: LibroMatrizRiesgosIAComponent,
            canActivate: [AuthGuard],
          },
          // «Cambios por aprobar»: el control de cambios de las matrices (lo
          // guardado con iso42001.matriz.aprobacion=true espera aqui a que
          // alguien con el perfil de edicion lo acepte o lo descarte). Sin
          // menu propio: se entra desde el libro (boton «Cambios por
          // aprobar», con ?idMatriz=N) y desde la tarjeta «Propuestas
          // pendientes» del Dashboard. El servidor exige el perfil en cada
          // accion; el guard solo mira la sesion, como en matriz/:idMatriz.
          {
            path: "cambiosPorAprobar",
            component: CambiosPorAprobarIAComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "hojasApoyoIA",
            component: HojasApoyoIAComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "altaRiesg",
            component: AltaRiesgoComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "consultaRiesg",
            component: ConsultaRiesgoComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "gestriesgos",
            component: GestionRiesgosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "riesgos/alta/:idProyecto",
            component: RiesgoEditorPageComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "MISPROYECTOS",
        children: [
          {
            path: "misproyectos",
            component: ConsultaHuCuxProyectoComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "AUDITORIA",
        children: [
          {
            path: "VISUALIZARPROY",
            component: GestionProyectosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/edicion/:id",
            component: ModalAddProyComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id",
            component: ProyectoPaginaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/proyecto/:id/version/:idVersion",
            component: DetalleVersionComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/alta/:idProyecto",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "VISUALIZARPROY/etapa/edicion/:idProyecto/:idEtapa",
            component: ModalAgregarEtapaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "consultaSeguimientos",
            component: ConsultaProyectosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "admproyectos",
            children: [
              {
                path: "",
                component: AdmProyectosComponent,
                canActivate: [AuthGuard],
                pathMatch: "full",
              },
              {
                path: "alta",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
              {
                path: "edicion/:id",
                component: ModalAddProyComponent,
                canActivate: [AuthGuard],
              },
            ],
          },
          {
            path: "gestriesgos",
            component: GestionRiesgosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "riesgos/alta/:idProyecto",
            component: RiesgoEditorPageComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "security",
        children: [
          { path: "login", component: LoginComponent },
          { path: "restorePass", component: RestauraPassComponent },
          { path: "password", component: PasswordComponent },
          { path: "tokens", component: TokensComponent },
          { path: "datospersonales", component: DatosPersonalesComponent },
        ],
      },
      {
        path: "denuncia",
        children: [
          // Públicos (sin AuthGuard para acceso externo)
          { path: "inicio", component: InicioDenunciasComponent },
          { path: "nuevo-reporte", component: AltaDenunciaComponent },
          { path: "confirmacion", component: ConfirmacionDenunciaComponent },
          { path: "", redirectTo: "inicio", pathMatch: "full" },
        ],
      },
    ],
  },
  {
    path: "**",
    component: DashboardComponent,
    canActivate: [redirigirRutaNoEncontrada],
  },
];
